<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'BillingEventComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'APP_INSTALLS', text: 'App Installs' },
        { value: 'CLICKS', text: 'Clicks' },
        { value: 'IMPRESSIONS', text: 'Impressions' },
        { value: 'LINK_CLICKS', text: 'Link Clicks' },
        { value: 'NONE', text: 'None' },
        { value: 'OFFER_CLAIMS', text: 'Offer Claims' },
        { value: 'PAGE_LIKES', text: 'Page Likes' },
        { value: 'POST_ENGAGEMENT', text: 'Post Engagement' },
        { value: 'THRUPLAY', text: 'Thruplay' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box @input="$emit('input', $event)" :items="items" label="Billing Event" v-bind="$attrs" />
</template>
